import { useInternet } from "./useInternet.js";

export function useResource(name) {
  let internet = useInternet();
  return {
    // Ask network, and update state

    list: (parameters = {}) => {
      return internet
        .get(`/${name}?${new URLSearchParams(parameters).toString()}`)
        .then(async (data) => {
          data = await data.json();
          return data;
        });
    },

    get: (id, parameters = {}) => {
      return internet
        .get(`/${name}/${id}?${new URLSearchParams(parameters).toString()}`)
        .then(async (data) => {
          data = await data.json();
          return data;
        });
    },

    create: (data, parameters = {}) => {
      return internet
        .post(
          `/${name}/new?${new URLSearchParams(parameters).toString()}`,
          data
        )
        .then(async (data) => {
          data = await data.json();
          return data;
        });
    },

    edit: (id, data, parameters = {}) => {
      return internet
        .post(
          `/${name}/${id || "new"}?${new URLSearchParams(
            parameters
          ).toString()}`,
          data
        )
        .then(async (data) => {
          data = await data.json();
          return data;
        });
    },

    delete: (ids, parameters = {}) => {
      if (!(ids instanceof Array)) {
        ids = [ids];
      }
      return internet
        .post(`/${name}/delete?${new URLSearchParams(parameters).toString()}`, {
          ids,
        })
        .then(async (data) => {
          data = await data.json();
          return data;
        });
    },

    collectionAction: (action, data) => {
      return internet.post(`/${name}/${action}`, data).then(async (data) => {
        data = await data.json();

        return data;
      });
    },
  };
}
